import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// REMOVED: import Backend from 'i18next-http-backend';

// Import translation files directly
import enCommon from '../locales/en/common.json';
import esCommon from '../locales/es/common.json';
import frCommon from '../locales/fr/common.json';
import deCommon from '../locales/de/common.json';
import itCommon from '../locales/it/common.json';
import ptCommon from '../locales/pt/common.json';

// Top Western languages: English, Spanish, French, German, Italian, Portuguese
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
  { code: 'pt', name: 'Português' },
];

// Define the configuration options separately
export const i18nConfig = {
  fallbackLng: 'en',
  debug: false, // Disable i18next debug logging
  interpolation: {
    escapeValue: false, // React already safes from XSS
  },
  // REMOVED: backend configuration
  // backend: {
  //   loadPath: '/locales/{{lng}}/{{ns}}.json',
  // },
  ns: ['common'], // Explicitly define the namespace(s)
  defaultNS: 'common',
  supportedLngs: SUPPORTED_LANGUAGES.map((lang) => lang.code),
  load: 'languageOnly' as const,
  react: {
    useSuspense: true, // Enable Suspense
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    bindI18nStore: '',
  },
  // Bundle all translations directly
  resources: {
    en: { common: enCommon },
    es: { common: esCommon },
    fr: { common: frCommon },
    de: { common: deCommon },
    it: { common: itCommon },
    pt: { common: ptCommon },
  },
  // Remove detection options, handled in provider
  // Remove initImmediate, controlled by provider
};

// Configure and initialize i18next instance synchronously
i18n
  // REMOVED: .use(Backend)
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init(i18nConfig); // Initialize synchronously

export default i18n;
